// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { GeneLink } from '../../../interfaces/hce/hce-sv';

export interface GenesDialogData {
    title: string;
    genes: GeneLink[];
}

@Component({
    selector: 'app-genes-list-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatListModule],
    templateUrl: './genes-list-dialog.component.html',
    styleUrls: ['./genes-list-dialog.component.css'],
})
export class GenesListDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: GenesDialogData,
        private dialogRef: MatDialogRef<GenesListDialogComponent>
    ) { }

    trackByIdx = (i: number) => i;

    openEnsembl(id?: string): void {
        if (!id) return;
        const url = `https://ensembl.org/Homo_sapiens/Gene/Summary?g=${encodeURIComponent(id)}`;
        window.open(url, '_blank', 'noopener');
    }

    close() {
        this.dialogRef.close();
    }
}
